import Notification, { NotificationEventType, SamplePointEvent } from 'types/models/notification';
import Trigger from 'types/models/trigger';

import { getNotificationEventType } from './notification-event-type';

export const getNotificationTrigger = (notification: Notification | null | undefined): Trigger | null => {
  if (!notification) return null;

  if (getNotificationEventType(notification.event) === NotificationEventType.SAMPLE_POINT_EVENT) {
    const event = notification.event as SamplePointEvent;

    return event.trigger || null;
  }

  return null;
};